export default __webpack_public_path__ + "static/media/background.86c3fbae.png";